import { faWater } from "@elynx/free-solid-svg-icons";
import { Box, Typography, useTheme } from "@mui/material";
import { format } from "date-fns/format";
import { useTranslation } from "react-i18next";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IObjectHistoryWaterLossEventItem } from "../../queries/object-history/Common";
import { ObjectHistoryCard } from "./ObjectHistoryCard";
import { ObjectHistoryCardContent } from "./ObjectHistoryCardContent";
import { ObjectHistoryCardHeader } from "./ObjectHistoryCardHeader";
import { ObjectHistoryCardSubheader } from "./ObjectHistoryCardSubheader";
import { ObjectHistoryEventItemAvatar } from "./ObjectHistoryEventItemAvatar";
import { getEventEndSummaryText, getEventEndSynopsisText, getEventStartSynopsisText, getWaterLossCauseText } from "./ObjectHistoryUtils";

export type ObjectHistoryWaterLossEventProps = {
    item: IObjectHistoryWaterLossEventItem;
    contextObject?: IeLynxObject;
};

export function ObjectHistoryWaterLossEventItem({ item, contextObject }: ObjectHistoryWaterLossEventProps) {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <ObjectHistoryCard>
            <ObjectHistoryCardHeader
                title={format(item.timestamp, "P pp")}
                avatar={<ObjectHistoryEventItemAvatar item={item} icon={faWater} />}
                subheader={
                    <ObjectHistoryCardSubheader
                        item={item}
                        createdBy={item.createdBy}
                        contextObject={contextObject}
                    />
                }
            >
            </ObjectHistoryCardHeader>
            <ObjectHistoryCardContent>
                {item.isStart
                    ? <Typography variant="body2">
                        {getEventStartSynopsisText(item)}
                        <Box component="span" style={{ fontWeight: "bold" }}>{`${getWaterLossCauseText(item)}.`}</Box>
                    </Typography>
                    : <>
                        <Typography variant="body2">{getEventEndSynopsisText(item)}</Typography>
                        <Typography variant="body2">
                            {t("objectHistory.eventItem.waterLossDueTo")}
                            <Box component="span" style={{ fontWeight: "bold" }}>
                                {getWaterLossCauseText(item)}
                            </Box>
                            {getEventEndSummaryText(item)}
                        </Typography>
                    </>
                }
                {item.notes &&
                    <Typography variant="body2" style={{ marginTop: theme.spacing(1) }}>
                        <span style={{ fontWeight: "bold" }}>Note:</span> {item.notes}
                    </Typography>
                }
            </ObjectHistoryCardContent>
        </ObjectHistoryCard>
    );
}
